import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/water.jpg";
import Card1 from "../Images/CIRCODU-BANNERS-2.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function WaterSanitation() {
  return (
    <div className="ne-page">
      <SEO
        title="Water and Sanitation"
        description="Access to clean, safe water is not a privilege; it is a fundamental human right. Yet across Uganda, countless communities still face the daily reality of insufficient access to clean water and adequate sanitation, with devastating consequences for health, education, and economic opportunity. CIRCODU is committed to changing that. Anchored in the principles of Sustainable Development Goal 6, we work alongside partners, governments, and communities to ensure that no one is left behind when it comes to water and sanitation."
        keywords="water and sanitation, clean water, safe water, fundamental human right, insufficient access, health consequences, education consequences, economic opportunity consequences, CIRCODU, Sustainable Development Goal 6, water and sanitation Uganda, clean water Uganda, safe water Uganda, water access Uganda, sanitation access Uganda, water and sanitation programs Uganda"
        url="/our-thematic-areas/water-and-sanitation"
        image={Card1}
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Water and Sanitation</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Our Thematic Areas
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Water and Sanitation
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Water and Sanitation</b>
              </h5>
              <p className="texty">
                Access to clean, safe water is not a privilege; it is a{" "}
                <b>fundamental human right</b>. Yet across Uganda, countless
                communities still face the daily reality of insufficient access
                to clean water and adequate sanitation, with devastating
                consequences for health, education, and economic opportunity.
              </p>
              <p className="texty">
                CIRCODU is committed to changing that. Anchored in the
                principles of <b>Sustainable Development Goal 6</b>, we work
                alongside partners, governments, and communities to ensure that
                no one is left behind when it comes to water and sanitation.
              </p>

              {/* Our Overall Objective */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🎯 Our Overall Objective</b>
              </h5>
              <p className="texty">
                To empower communities facing insufficient access to clean water
                and adequate sanitation, ensuring access to{" "}
                <b>safe drinking water and improved hygiene practices</b> that
                protect health, restore dignity, and build a foundation for
                lasting well-being.
              </p>

              {/* Specific Objectives */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🔑 Specific Objectives</b>
              </h5>
              <ol className="texty mt-2">
                <li className="mt-2">
                  <b>Safe Drinking Water for All:</b> We work to provide safe
                  drinking water that meets{" "}
                  <b>World Health Organization (WHO) guidelines:</b> sourced
                  from improved water points that are on-premises, available
                  when needed, and free from faecal and chemical contamination.
                  Because clean water should never be a matter of luck.
                </li>
                <li className="mt-2">
                  <b>Reducing Disease Burden:</b> By increasing access to clean
                  water and sanitation, we directly reduce the incidence of{" "}
                  <b>
                    diarrhoeal diseases, soil-transmitted helminthiases, and
                    other neglected tropical diseases (NTDs)
                  </b>{" "}
                  that undermine child development, school attendance, and
                  community productivity, ultimately lowering healthcare costs
                  and unlocking economic opportunity.
                </li>
                <li className="mt-2">
                  <b>Protecting Water Resources:</b> We are committed to
                  safeguarding water quality for human health, maintaining
                  healthy ecosystems, and promoting{" "}
                  <b>responsible water use and resource management</b> that
                  supports sustainable economic development for generations to
                  come.
                </li>
                <li className="mt-2">
                  <b>Hygiene Behavior Change:</b> Infrastructure alone is not
                  enough. Through targeted education and awareness campaigns, we
                  empower communities, especially women, children, and
                  vulnerable groups, to adopt the healthy hygiene practices that
                  complement and sustain improved water and sanitation systems.
                </li>
              </ol>
            </div>
            <div className="col-md-8">
              {/* Our Actions on the Ground */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚙️ Our Actions on the Ground</b>
              </h5>
              <ol className="texty mt-1">
                <li>
                  🏗️ <b>Construction of Water Infrastructure:</b> In partnership
                  with communities, local governments, and development partners,
                  CIRCODU constructs and rehabilitates critical water points,
                  including{" "}
                  <b>wells, boreholes, and rainwater harvesting systems,</b> to
                  bring safe drinking water closer to those who need it most.
                </li>
                <li className="mt-1">
                  🔵 <b>Water Treatment and Quality Testing:</b> We implement
                  water treatment and purification systems and conduct regular
                  quality testing to ensure all water sources consistently meet
                  WHO standards and remain free from harmful contaminants. Clean
                  water, verified.
                </li>
                <li className="mt-1">
                  🌸 <b>Hygiene Promotion and Behavior Change:</b> Our community
                  hygiene education programs promote{" "}
                  <b>
                    handwashing with soap, safe water storage, and healthy
                    sanitation practices
                  </b>{" "}
                  delivered with a particular focus on reaching women, children,
                  and the most vulnerable members of society.
                </li>
                <li className="mt-1">
                  🔧 <b>Capacity Building for Water Management Committees:</b>{" "}
                  Sustainable water access requires community ownership. CIRCODU
                  trains <b>community water management committees</b> to
                  operate, maintain, and manage water infrastructure
                  independently, ensuring long-term functionality and local
                  stewardship of water resources.
                </li>
                <li className="mt-1">
                  🔔 <b>Advocacy for Water and Sanitation Policies:</b> Change
                  must also happen at the policy level. CIRCODU engages with
                  government agencies and policymakers to advocate for{" "}
                  <b>
                    increased investment in water and sanitation infrastructure
                  </b>{" "}
                  and the development of policies that protect water resources
                  and guarantee equitable access for all communities.
                </li>
              </ol>
            </div>
            <div
              className="col-md-4 mb-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="imagecard" style={{ width: "100%" }}>
                <img
                  src={Card1}
                  alt="CIRCODU Water and Sanitation Programs"
                  width="100%"
                  style={{ borderRadius: "5%", objectFit: "cover" }}
                />
              </div>
            </div>

            <hr />
            <div className="col-md-12">
              {/* Closing statement */}
              <p className="texty">
                <i>
                  Every drop counts. Every community deserves better. At
                  CIRCODU, clean water is not just a project; it's a promise.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WaterSanitation;
